// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_1nBqEsW","container":"_28cskfg","innerContainer":"_2f-FfrQ","avatar":"_21BF8ds","nameContainer":"_2ALJDT5","name":"_3hSBkv8","backIcon":"_qvDp2mv"};